import {
  NullableBooleanSetting,
  useUserSettingWithDefault,
} from "shared-ts-utils-user-settings";

export const useConsentToMonitorIssuesWithNullAsDefault = () => {
  return useUserSettingWithDefault<boolean | null>(
    "consentToMonitorIssues",
    NullableBooleanSetting,
    null
  );
};
